import { createApp } from 'vue'
import { createPinia } from 'pinia' // 1. Import Pinia
import Vue3Sanitize from "vue-3-sanitize";
import App from './App.vue'
import router from './router'
import './assets/style.css' // Importen av din v4-CSS

const app = createApp(App)
const pinia = createPinia() // 2. Create the instance

app.use(Vue3Sanitize, {allowedTags: []} )
app.use(pinia)  // 3. Register Pinia FIRST 🍍
app.use(router) // 4. Register Router SECOND

app.mount('#app')
